import crossicon from './../../../assets/icons/cross.png'
export default function Popup({children,handelClose}){
    return(<div className="popup_inner">
        {handelClose && <img onClick={handelClose} className='crossIcon' src={crossicon}/>}
         {children}
    </div>)
}